import _ from 'lodash';
import { KibanaFilterType, ElasticFilterType } from '../filter-interfaces';
import IsOneOfFilterModel from '../models/is-one-of-filter-model';
import KibanaFilterMetadata from '../metadatas/osd-filter-metadata';
import BaseFilterParser from './base-filter-parser';
export class KibanaIsOneOfFilterMetadata extends KibanaFilterMetadata {
    params;
    constructor(params, key, value, negate = false, indexPattern, alias = null, disabled = false) {
        super(key, value, KibanaFilterType.Phrases, negate, indexPattern, alias, disabled);
        this.params = params;
    }
}
/**
 * Elastic to Kibana 'IS-ONE-OF' filter parser
 */
export default class IsOneOfFilterParser extends BaseFilterParser {
    constructor() {
        super(KibanaFilterType.Phrases, ElasticFilterType.Bool);
    }
    getMetadata(filter, negate = false, indexPattern) {
        let retVal = null;
        if (filter[this.elasticKey] && this.isShouldFilterExist(filter)) {
            const key = this.getFieldName(filter.bool?.should?.[0]?.match_phrase ?? {});
            const values = _.map(filter.bool?.should, (value) => {
                if (value.match_phrase)
                    return value.match_phrase[key];
            }).filter(Boolean);
            retVal = new KibanaIsOneOfFilterMetadata(values, key, values.join(', '), negate, indexPattern);
        }
        return retVal;
    }
    getFilter(metadata) {
        if (!this.assertType(metadata))
            return null;
        return new IsOneOfFilterModel(metadata);
    }
    isShouldFilterExist(filter) {
        return Array.isArray(filter.bool?.should) && filter.bool?.should?.[0]?.match_phrase !== undefined;
    }
}
//# sourceMappingURL=is-one-of-filter-parser.js.map